import * as ActivityInterventionBasic from './activityInterventionBasic.js';
export default ActivityInterventionBasic;
